import React from "react";
import { motion } from "framer-motion";
import {
  FaHeart,
  FaVideo,
  FaMapMarkerAlt,
  FaUsers,
  FaClock,
  FaStar,
  FaCalendarAlt,
  FaSearch,
  FaGift,
} from "react-icons/fa";

const AppPreviewSection = () => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        delayChildren: 0.1,
        staggerChildren: 0.08,
      },
    },
  };

  const itemVariants = {
    hidden: { y: 50, opacity: 0 },
    visible: {
      y: 0,
      opacity: 1,
      transition: {
        duration: 0.8,
        ease: "easeOut",
      },
    },
  };

  return (
    <section className="py-20 relative w-full">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-7xl">
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, amount: 0.3 }}
          className="text-center"
        >
          {/* Section Header */}
          <motion.div variants={itemVariants} className="mb-16">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              From places you like…
            </h2>
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              <span className=" gradient-text">To people you might love.</span>
            </h2>
            <p className="text-xl text-gray-300 max-w-2xl mx-auto">
            Experience the future of dating with our beautifully designed app, showcasing these features you won’t find on any other
            </p>
          </motion.div>

          {/* Phone Mockup */}
          <motion.div
            variants={itemVariants}
            className="flex justify-center mb-16"
          >
            <motion.div
              className="relative"
              whileHover={{ scale: 1.05 }}
              transition={{ type: "spring", stiffness: 300 }}
            >
              {/* Phone Frame */}
              <div className="w-80  ">
                {/* Screen */}
                <img src="/assets/phone-frem-girl.png" alt="" />
                {/* <div className="w-full h-full bg-gradient-to-br from-night-sky to-deep-purple rounded-[2.5rem] relative overflow-hidden">
                                    
                </div> */}
              </div>

              {/* Floating Elements */}
              <motion.div
                className="absolute -top-4 -right-4 w-8 h-8 bg-gradient-to-br from-romantic-pink to-yellow-400 rounded-full flex items-center justify-center"
                animate={{
                  y: [0, -10, 0],
                  rotate: [0, 180, 360],
                }}
                transition={{ duration: 4, repeat: Infinity }}
              >
                <FaHeart className="text-white text-sm" />
              </motion.div>

              <motion.div
                className="absolute -bottom-4 -left-4 w-6 h-6 bg-gradient-to-br from-romantic-blue to-romantic-purple rounded-full flex items-center justify-center"
                animate={{
                  y: [0, 10, 0],
                  rotate: [360, 180, 0],
                }}
                transition={{ duration: 3, repeat: Infinity, delay: 1 }}
              >
                <FaVideo className="text-white text-xs" />
              </motion.div>
            </motion.div>
          </motion.div>

          {/* Feature Highlights - 5 Points */}
          <motion.div
            variants={itemVariants}
            className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5 gap-6 max-w-6xl mx-auto"
          >
            {[
              {
                icon: FaSearch,
                title: "Meet Match",
                desc: "Venues first, matches second",
                gradient: "from-romantic-purple to-romantic-pink",
              },
              {
                icon: FaGift,
                title: "datenite dates",
                desc: "Big dates, smaller prices",
                gradient: "from-romantic-blue to-romantic-purple",
              },
              {
                icon: FaCalendarAlt,
                title: "Tonight?",
                desc: "Create or reply to Personal Ads",
                gradient: "from-romantic-pink to-yellow-400",
              },
              {
                icon: FaMapMarkerAlt,
                title: "Meet Map",
                desc: "The map that matches you",
                gradient: "from-yellow-400 to-romantic-pink",
              },
              {
                icon: FaClock,
                title: "Datenite",
                desc: "Video speed dates, nightly",
                gradient: "from-romantic-pink to-orange-400",
                highlight: true,
              },
            ].map((feature, i) => (
              <motion.div
                key={i}
                className="text-center"
                whileHover={{ y: -8, scale: 1.05 }}
                transition={{ type: "spring", stiffness: 300 }}
              >
                <motion.div 
                  className={`w-16 h-16 bg-gradient-to-br ${feature.gradient} rounded-full flex items-center justify-center mx-auto mb-4 shadow-lg ${
                    feature.highlight ? 'ring-2 ring-yellow-400 ring-opacity-50' : ''
                  }`}
                  whileHover={{ rotate: 360 }}
                  transition={{ duration: 0.6 }}
                >
                  <feature.icon className="text-white text-xl" />
                </motion.div>
                <h4 className={`font-bold mb-2 ${
                  feature.highlight ? 'text-yellow-400' : 'text-white'
                }`}>
                  {feature.title}
                </h4>
                <p className="text-gray-400 text-sm leading-relaxed">{feature.desc}</p>
              </motion.div>
            ))}
          </motion.div>
        </motion.div>
      </div>
    </section>
  );
};

export default AppPreviewSection;
